import { useSelector } from "react-redux";
import { loadingServiceSlice } from "../StateManagement/loadingServiceSlice";

export const useLoadPageState = () => {
  const loading = useSelector(
    (state) => state?.[loadingServiceSlice.name]?.loadingPage
  );
  return loading;
};
